<div class="topnav-container">
    <app-topnav [ShowCart]="false"></app-topnav>
</div>
<div class="checkout-container">
    <div class="info-wrapper">
        <p>A sua sessão foi terminada, aguarde...</p>
    </div>
</div>